<script>
    import { Star } from "lucide-svelte";

    let { path, label, current = false, favorite = false, onToggleFavorite } = $props();
    let busy = $state(false);

    async function toggleFavorite() {
        if (busy) return;
        busy = true;
        try {
            await onToggleFavorite(path, !favorite);
        } finally {
            busy = false;
        }
    }
</script>

<li class="sidebar-menu-item">
    <a href={path} aria-current={current ? "page" : undefined}>{label}</a>
    <button
        type="button"
        class="sidebar-favorite-toggle textButton"
        class:selected={favorite}
        aria-label={`${label} 즐겨찾기 ${favorite ? "해제" : "추가"}`}
        aria-pressed={favorite}
        disabled={busy}
        onclick={toggleFavorite}
    >
        <Star size={16} fill={favorite ? "currentColor" : "none"} />
    </button>
</li>
